<template>
  <div @keyup.ctrl.space="speak" @click="disableSpeak">
    <md-tabs class="md-transparent" @change="changed">
      <md-tab v-for="o in opt" :id="o.value" :md-label="o.text" :key="o.value" 
	      :md-active="selected == o.value">
	<template v-if="selected == o.value">
	  <input type="hidden" :name="sel_name" :value="selected" />
	  <div v-for="c in custom" v-if="selected == c.value" :key="c.value">
            <simple-element :el="c.el"></simple-element>
	  </div>
	</template>
      </md-tab>
<!--      
      <md-tab id="tab-home" md-label="Home" ref="home">
        Home Tab
      </md-tab>
      <md-tab id="tab-pages" md-label="Pages" to="/components/tabs/pages">
        Pages tab
        <p>Unde provident nemo reiciendis officia, possimus repellendus. Facere dignissimos dicta quis rem. Aliquam aspernatur dolor atque nisi id deserunt laudantium quam repellat.</p>
      </md-tab>
      <md-tab id="tab-posts" md-label="Posts" to="/components/tabs/posts">
        Posts tab
        <p>Qui, voluptas repellat impedit ducimus earum at ad architecto consectetur perferendis aspernatur iste amet ex tempora animi, illum tenetur quae assumenda iusto.</p>
      </md-tab>
      <md-tab id="tab-favorites" md-label="Favorites" to="/components/tabs/favorites">
        Favorites tab
        <p>Maiores, dolorum. Beatae, optio tempore fuga odit aperiam velit, consequuntur magni inventore sapiente alias sequi odio qui harum dolorem sunt quasi corporis.</p>
      </md-tab>
-->
    </md-tabs>
  </div>
</template>
    
<script>
var $ = require('jquery')
import store from '@/store'

var speechMsg = null;
if('SpeechSynthesisUtterance' in window)
    speechMsg = new SpeechSynthesisUtterance()

export default {
    name: 'custom-tabs',
    props: ['el'],
    data() {
	return {
	    selected: '',
	    opt: [{
		value: '',
		text: ''
	    }],
	    custom: [{
		value: '',
		el: ''
	    }],
	    enableSpeak: false
	}
    },
    computed: {
	sel_name: function() {
	    //console.log(this.el.firstElementChild.getAttribute("name"))
	    return this.el.firstElementChild.getAttribute("name")	    
	},
    },
    methods: {
	changed: function(index) {
	    //console.log(this.enableSpeak)
	    //if(this.enableSpeak && (this.selected != this.opt[index].value))
	    if(this.enableSpeak)
		if('SpeechSynthesisUtterance' in window) {
		    speechMsg.text = this.opt[index].text+" が有効"
		    speechSynthesis.speak(speechMsg)
		}
	    this.selected = this.opt[index].value
            //console.log(this.opt[index].text)

	    store.setSingleGetPrices(false)
	    if(!this.$store.state.mdfLoad) {
		this.$store.commit('customSelectChange',true)
	    }
	},
	speak: function() {
	    console.log("space key pressed")
	    this.enableSpeak = true
	},
	disableSpeak: function() {
	    console.log("disable speaking")
	    this.enableSpeak = false
	}
    },
    updated() {
	if(this.$store.state.customSelectChanged) {
	    this.$store.dispatch("checkPrice")
	    this.$store.commit('customSelectChange',false)
	    //console.log("changed")
	}
    },
    beforeMount() {
	if('SpeechSynthesisUtterance' in window) {
	    //console.log(this.$i18n.locale)
	    speechMsg.lang = ('ja'==this.$i18n.locale) ? "ja-JP" : "en-US"
	    //speechMsg.volume = 0
	}
	
	//console.debug(this.simpleEl)
	//SimpleEl.name = 'simple-element'
	const option = $(this.el.firstElementChild).children()
	this.opt = []
	for(let i=0; i<option.length; i++) {
	    //option[i].getAttribute('value')
	    this.opt.push({
		value: option[i].getAttribute('value'),
		text: $(option[i]).text()
	    })
	    if((i==0)||option[i].hasAttribute('selected'))
		this.selected = option[i].getAttribute('value')
	}
	//console.log(this.opt)
	
	//const div = $(this.el).find("blockquote div")
	const div = $(this.el).children("blockquote").children("div")
	this.custom = []
	for(let i=0; i<div.length; i++) {
	    //console.log(div[i])
	    this.custom.push({
		value: div[i].getAttribute('value'),
		el: div[i]
	    })
	}
	//console.log(this.sel_name, this.custom)
    },
    /* mounted() {
	//console.log(this.$refs['tabs'].activeTab )
	this.setSelected()
	} */
    components: {
    }
}
</script>

<style>
  .md-tabs .md-tabs-navigation {
    height: 25px;
    min-height: 25px;
  }
  .md-tabs .md-tab {
    padding: 2px;
  }
  .md-theme-default.md-tabs>.md-tabs-navigation .md-tab-header {
      background-color: #ccd0e6;
  }
</style>



// WEBPACK FOOTER //
// CustomTabs.vue?4be776ca